import { combineReducers} from 'redux';
import projectsReducer from './projects_reducer';
import additionalProjectsReducer from './additional_reducer';

const reducers = {
  projectsStore: projectsReducer,
  additionalProjectsStore: additionalProjectsReducer, 
};

export default combineReducers(reducers);
